module.exports = __webpack_public_path__ + "img/bot.8b232b26.svg";